export default __webpack_public_path__ + "static/media/COPYPASTE2.1811184d.svg";